/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerdescriptionplaceholder2Inputs */

const en_flyerdescriptionplaceholder2 = /** @type {(inputs: Flyerdescriptionplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live music from 7pm, grill and cocktails.`)
};

const de_flyerdescriptionplaceholder2 = /** @type {(inputs: Flyerdescriptionplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livemusik ab 19 Uhr, Grill und Cocktails.`)
};

/**
* | output |
* | --- |
* | "Live music from 7pm, grill and cocktails." |
*
* @param {Flyerdescriptionplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerdescriptionplaceholder2 = /** @type {((inputs?: Flyerdescriptionplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerdescriptionplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerdescriptionplaceholder2(inputs)
	return de_flyerdescriptionplaceholder2(inputs)
});
export { flyerdescriptionplaceholder2 as "flyerDescriptionPlaceholder" }